
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class VerticalScrollList extends Vue {
  @Prop({ required: true }) private items!: any[];
  @Prop({ required: false }) private nItems?: number;
  @Prop({ required: false, default: () => ({}) })
  private bannerListStyle!: object;

  private currentIndex: number = 0;
  windowWidth: number = window.innerWidth;

  private get itemsToShow() {
    return this.nItems && this.items
      ? this.items.slice(0, this.nItems)
      : this.items;
  }

  // @Watch("items", { immediate: true, deep: true })
  // onItemsChanged() {
  //   this.$nextTick(() => {
  //     const list = this.$refs.bannerList as HTMLElement | null;
  //     if (list) {
  //       list.scrollTop = 0;
  //     }
  //   });
  // }

  async mounted() {
    window.scrollTo({ top: 0, behavior: "auto" });
  }

}
